import { cn } from '@packages/shared/src/utils/cn/cn';
import type { HTMLAttributes, ReactNode } from 'react';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';

type ContentProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const ContentWrapper = ({ children, className, ...props }: ContentProps) => (
  <div className={cn('divide-color-grey divide-y py-1', className)} {...props}>
    {children}
  </div>
);

export type ContentWrapperContentProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const ContentWrapperContent = ({
  children,
  className,
  ...props
}: ContentWrapperContentProps) => {
  const {
    installmentCalculator: { InstallmentCalculatorCallToActionLayout },
  } = useConfig();

  return (
    <div
      className={cn(
        'flex flex-row flex-nowrap gap-1.5 pb-1',
        `${InstallmentCalculatorCallToActionLayout?.layout !== 'Layout3' ? 'px-2' : 'items-start px-1'}`,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

type ContentWrapperCallToActionProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const ContentWrapperCallToAction = ({
  className,
  children,
  ...props
}: ContentWrapperCallToActionProps) => {
  const {
    installmentCalculator: { InstallmentCalculatorCallToActionLayout },
  } = useConfig();

  return (
    <div
      className={cn(
        'pt-1',
        `${InstallmentCalculatorCallToActionLayout?.layout !== 'Layout3' ? 'text-size-body2 cursor-pointer px-2 text-center' : 'text-size-h5 px-1 text-left'}`,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
